
<swiper-container #swiperContainerRef [class.show-overflow]="$any(swiper)?.params?.showOverflow" [class.reduced-width]="$any(swiper)?.params?.reducedWidth" [class.multiple-items]="slides()?.length > (+swiper?.params?.slidesPerView || 1)">
  @for (slide of slides(); track slide; let i = $index) {
    <swiper-slide>
      @if (renderedIndexes().has(i)) {
        <ng-container *ngTemplateOutlet="swiperContent?.template; context: { index: i, item: slide }"></ng-container>
      }
    </swiper-slide>
  }
</swiper-container>

@if ($any(swiper)?.params?.navigation?.enabled && slides()?.length > 1) {
  <div class="swiper-buttons-wrapper" [class.buttons-wide]="$any(swiper)?.params?.navigation?.wide">
    <button #buttonPrev color="primary" mat-fab aria-label="Previous" class="swiper-button swiper-button-prev" [disabled]="swiper?.isBeginning && !swiper?.params?.loop" (click)="swiper.slidePrev()">
      <lib-icon icon="arrow-left" [size]="16"></lib-icon>
    </button>
    <button #buttonNext color="primary" mat-fab aria-label="Next" class="swiper-button swiper-button-next" [disabled]="swiper?.isEnd && !swiper?.params?.loop" (click)="swiper.slideNext()">
      <lib-icon icon="arrow-right" [size]="16"></lib-icon>
    </button>
  </div>
}
